export default "__VITE_ASSET__UgGZk6fl__"